export default class ActivityPolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, queue) {
        return this.gate.allow('read', 'queue', queue);
    }

    add(user, queue) {
        return this.gate.allow('edit', 'queue', queue);
    }

    edit(user, activity, queue) {
        return activity.deleted_at === null
            && this.gate.allow('edit', 'queue', queue);
    }

    destroy(user, activity, queue) {
        return activity.deleted_at === null
            && this.gate.allow('edit', 'queue', queue);
    }

    restore(user, activity, queue) {
        return activity.deleted_at !== null
            && this.gate.allow('edit', 'queue', queue);
    }

    sort(user, activity, queue) {
        return this.gate.allow('edit', 'queue', queue);
    }

    updateSortIndex(user, activity, queue, destination) {
        if (!this.sort(user, activity, queue)) {
            return false;
        }

        if (!destination) {
            return false;
        }

        return activity.sort_index !== Number(destination);
    }
}
